import { preparePayloadForGraphQL } from '@/helpers/validate';

/**
 * Field of the block project-power-company ("EVU") with its payload type
 * (`preparePayloadForGraphQL`). Must match `ProjectPowerCompanyInput`; `createPayload` reuses the
 * type.
 */
export const PROJECT_POWER_COMPANY_FIELD_TYPES = {
  powerCompany: 'id',
};

export const PROJECT_POWER_COMPANY_INPUT_FIELDS = Object.keys(PROJECT_POWER_COMPANY_FIELD_TYPES);

/** `ProjectPowerCompanyInput` from the block object: the id of the selected power company or null. */
export const toProjectPowerCompanyInput = (project) =>
  preparePayloadForGraphQL(
    { powerCompany: project.powerCompany ?? null },
    PROJECT_POWER_COMPANY_FIELD_TYPES
  );
